import http from "@/js/http";

export async function aiUsageLimit(serverKey: string) {
  const usageLimit = await http.get("/Ai/fetchAiUsageLimit?serverKey=" + serverKey);
  return usageLimit.data.success;
}
